<div class="order-history-container pt-5">
    <div class="table-controls-container" *ngIf="(salesReturns$ |async)?.length; let count">
        <div class="header-container flex flex-row justify-between items-center">
            <div class="flex flex-col">
                <div class="text-title-2">Sales to Providers</div>
                <div class="sub-header">
                There {{count !== 1 ? 'are' : 'is'}}
                <div class="bold">{{count}}</div>
                sale{{count !== 1 ? 's' : ''}} to provider{{count !== 1 ? 's' : ''}}
                </div>
            </div>
            <app-button 
                text="Create Sale to Provider"
                [minWidth]="190"
                (clicked)="openSaleToProviderDialog()">
            </app-button>
        </div>

        <div class="table-controls search-control">
            <app-search-input
                [color]="SearchInputColorEnum.Green"
                [hideDropdown]="true"
                placeholder="Search by provider, PO#, CSOS# or invoice#"
                [loading]="loading$ | async"
                (searchValueChanged)="searchValueChanged($event)"
            ></app-search-input>
        </div>
    </div>

    <app-button *ngIf="!(salesReturns$ |async)?.length && !(loading$ | async)"
        class="!flex justify-end pr-8"
        text="Create Sale to Provider"
        [minWidth]="190"
        (clicked)="openSaleToProviderDialog()">
    </app-button>

    <app-generic-table *ngIf="(salesReturns$ |async)?.length"
        [data]="filteredSales$ | async" 
        [columns]="columns"
        (goToDetail)="openDetail($event)"
    ></app-generic-table>
</div>

<app-sell-return-order-dialog *ngIf="sellToProviderDialog"
    dialogHeader="Create Sale to Provider"
    [activityType]="ActivityTypesEnum.SoldToProvider"
    (itemAdded)="addProvider($event)"
    (submit)="saleToProviderSubmitted($event)"
    (cancel)="sellToProviderDialog = false"
></app-sell-return-order-dialog>

<app-empty-table *ngIf="!(loading$ | async) && !(salesReturns$ | async)?.length"
  [labelValue]="'You do not have any orders yet'"
></app-empty-table>

